import ReportUtils from "../../../../../../utils/report-utils.js";
import InfoGrid from "../../../../../../components/info-grid/info-grid.jsx";

export default function AgentsDocuments({ data }) {
    const docs = data?.documents ?? {};

    const docsInfo = [
        {
            subTitle: "RG",
            items: [
                {
                    label: "Número",
                    value: docs?.rg ?? "",
                    className: 'print:mt-[-3px]!'
                },
                {
                    label: "Emissor",
                    value: docs?.emitterRg ?? "",
                    className: 'print:mt-[-3px]!'
                },
                {
                    label: "Data de emissão",
                    value: ReportUtils.formatDateOnly(docs?.expeditionRg ?? ""),
                    className: 'print:mt-[-3px]!',
                    span: 2
                },
            ]
        },
        {
            subTitle: "CNH",
            items: [
                {
                    label: "Número",
                    value: docs?.cnh ?? "",
                },
                {
                    label: "Data de emissão",
                    value: ReportUtils.formatDateOnly(docs?.emitterCnh ?? ""),
                },
                {
                    label: "Data de vencimento",
                    value: ReportUtils.formatDateOnly(docs?.expirationCnh ?? ""),
                },
                {
                    label: "Categoria",
                    value: docs?.categoryCnh ? docs?.categoryCnh?.join(", ") : "",
                }
            ]
        },
        {
            subTitle: "CTPS",
            items: [
                {
                    label: "Registro",
                    value: docs?.workRegister ?? "",
                },
                {
                    label: "Série",
                    value: docs?.workSerie ?? "",
                },
                {
                    label: "Data de emissão",
                    value: ReportUtils.formatDateOnly(docs?.emitterWork ?? ""),
                    span: 2
                },
            ]
        },
        {
            subTitle: "PIS/PASEP",
            items: [
                {
                    label: "Registro",
                    value: docs?.pisPasep ?? "",
                },
                {
                    label: "",
                    value: " ",
                },
                {
                    label: "",
                    value: " ",
                },
                {
                    label: "",
                    value: " ",
                }
            ]
        },
        {
            subTitle: "Informações de eleitor",
            items: [
                {
                    label: "Título",
                    value: docs?.voterRegister ?? "",
                },
                {
                    label: "Zona",
                    value: docs?.voterZone ?? "",
                },
                {
                    label: "Seção",
                    value: docs?.voterSection ?? "",
                    span: 2
                },
            ]

        },
        {
            subTitle: "Porte de arma",
            items: [
                {
                    label: "Número de licença",
                    value: docs?.licenseNumber ?? "",
                },
                {
                    label: "Número da cautela",
                    value: docs?.cautionNumber ?? "",
                },
                {
                    label: "Data de expedição",
                    value: ReportUtils.formatDateOnly(docs?.carryShippingDate ?? ""),
                },
                {
                    label: "Data de vencimento",
                    value: ReportUtils.formatDateOnly(docs?.carryDueDate ?? ""),
                }
            ]
        },
        {
            subTitle: "Exame de tiro",
            items: [
                {
                    label: "Data de expedição",
                    value: ReportUtils.formatDateOnly(docs?.shotShippingDate ?? ""),
                },
                {
                    label: "Data de vencimento",
                    value: ReportUtils.formatDateOnly(docs?.shotDueDate ?? ""),
                    span: 2
                },
            ]
        },
        {
            subTitle: "Exame psicológico",
            items: [
                {
                    label: "Data de expedição",
                    value: ReportUtils.formatDateOnly(docs?.psychoShippingDate ?? ""),
                },
                {
                    label: "Data de vencimento",
                    value: ReportUtils.formatDateOnly(docs?.psychoDueDate ?? ""),
                    span: 2
                },
            ]
        },
        {
            subTitle: "CRAF",
            items: [
                {
                    label: "Data de expedição",
                    value: ReportUtils.formatDateOnly(docs?.crafShippingDate ?? ""),
                },
                {
                    label: "Data de vencimento",
                    value: ReportUtils.formatDateOnly(docs?.crafDueDate ?? ""),
                    span: 2
                }
            ]
        },

        {
            subTitle: "Certificado de reservista",
            items: [
                {
                    label: "Número RA",
                    value: docs?.reservistRaNumber ?? "",
                },
                {
                    label: "Data de vencimento",
                    value: ReportUtils.formatDateOnly(docs?.reservistDate ?? ""),
                    span: 2
                }
            ]
        },
        {
            subTitle: "Exame toxicológico",
            items: [
                {
                    label: "Data de expedição",
                    value: ReportUtils.formatDateOnly(docs?.toxicologicalShippingDate ?? ""),
                },
                {
                    label: "Data de vencimento",
                    value: ReportUtils.formatDateOnly(docs?.toxicologicalDueDate ?? ""),
                    span: 2
                }
            ]
        },
        {
            subTitle: "Habilitação para arma longa",
            className: "print:mb-5! mb-2!",
            items: [
                {
                    label: "Data de expedição",
                    value: ReportUtils.formatDateOnly(docs?.longGunLicenceShippingDate ?? ""),
                },
                {
                    label: "Data de vencimento",
                    value: ReportUtils.formatDateOnly(docs?.longGunLicenceDueDate ?? ""),
                    span: 2
                }
            ]
        }
    ]

    return (
        <>
            <InfoGrid title={'Documentos'} items={docsInfo} columns={4} contentClassName={'gap-y-2! gap-x-2! mt-[-6px]'} subTitleClassName={'mb-[-6px]!'} divisorClassName={'print:mt-2!'} labelClassName={'text-[#4F4F4F] text-[13px]!'} className={'px-0!'} divisor={true}/>
        </>
    )
}